import classNames from 'classnames';
import { Children, cloneElement, isValidElement } from 'react';

import useStyles from './styles';
import IFileList from './types';

function FileList({ disabled, className, children, largeSingle, onDelete }: IFileList) {
  const classes = useStyles();

  return (
    <ul className={classNames(classes.root, className)}>
      {Children.map(children, (child, index) => {
        if (isValidElement(child)) {
          return cloneElement(child, {
            disabled,
            onDelete: onDelete && (() => onDelete(index)),
            large: largeSingle && Children.count(children) === 1,
          });
        }

        return child;
      })}
    </ul>
  );
}

export default FileList;
